import { useInsightInfos } from "scenes/Hubly/components/Workspace/components/InsightMenu/hooks";

export function useUserInformationManager() {
  const insights = useInsightInfos("reportButton");

  return {
    showColumn: {
      insights: insights.length > 0,
    },
  };
}

export default useUserInformationManager;
